import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';

// template: `<audio #audio [src]="src" [controls]="controls" [preload]="preload"></audio>`,

// https://github.com/spencerudnick/audio-ng
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'htmlAudio',
  templateUrl: './html-audio.component.html',
  styleUrls: ['./html-audio.component.css']
})
export class HtmlAudioComponent implements OnInit, OnDestroy {
  @Input() src: string;
  @Input() controls: boolean;
  @Input() preload? = 'auto';
  @Input() index?: number;
  @Input() autoPlay: boolean;
  @Output() register: EventEmitter<HtmlAudioComponent> = new EventEmitter();
  @Output() audioEvents: EventEmitter<any> = new EventEmitter();
  @ViewChild('audio', { static: true }) element: ElementRef;

  interval: any;

  loaded = false;

  loopParams = {
    on: false,
    paused: false,
    start: 0,
    duration: 5000
  };

  componentRef: any = this;

  constructor() { }

  ngOnInit() {
    
    this.element.nativeElement.addEventListener('canplay', ($event) => {
      this.Media_canplay($event); 
    }, false);       
    this.element.nativeElement.addEventListener('canplaythrough', ($event) => {
      this.Media_canplaythrough($event);
    }, false);
    this.element.nativeElement.addEventListener('loadstart', ($event) => {
      this.Media_loadstart($event);
    }, false);
    // this.element.nativeElement.addEventListener('loadeddata', this.Media_loadeddata, false);
    this.element.nativeElement.addEventListener('ended', ($event) => {this.Media_ended($event);
    }, false);
    this.element.nativeElement.addEventListener('play', ($event) => {this.Media_play($event);
    }, false);

    this.element.nativeElement.addEventListener('pause', ($event) => {
      this.Media_pause($event);
    }, false);
    
    this.element.nativeElement.addEventListener('seeking', ($event) => {
      this.Media_seeking($event);
    }, false);

    this.element.nativeElement.addEventListener('seeked', ($event) => {
      this.Media_seeked($event);
    }, false);

    this.element.nativeElement.addEventListener('playing', ($event) => {
      this.Media_playing($event);
    }, false);
    this.element.nativeElement.addEventListener('progress', ($event) => {
      this.Media_progress($event);
    }, false);
    this.element.nativeElement.addEventListener('volumechange', ($event) => {
      this.Media_volumechange($event);
    }, false);
    // this.element.nativeElement.addEventListener('loadeddata', this.Media_loadeddata, false);
    // this.element.nativeElement.addEventListener('loadeddata', this.Media_loadeddata, false);
    this.element.nativeElement.addEventListener('loadeddata', () => {
      this.sendRegistration();
    }, false);
  }

  Media_canplay($event) {
    this.audioEvents.emit({'eventName': 'Can Play'});
  }
  Media_canplaythrough($event) {
    this.audioEvents.emit({'eventName': 'Can Play Through'});
  }
  Media_loadstart($event) {
    this.audioEvents.emit({'eventName': 'Load Started'});
  }
  Media_ended($event) {

  }
  Media_error($event) {

  }
  Media_loadeddata($event) {
    this.audioEvents.emit({'eventName': 'Load Complete'});
  }
  Media_play($event) {
    this.audioEvents.emit({'eventName': 'Play Clicked'});
  }
  Media_playing($event) {
    this.audioEvents.emit({'eventName': 'Playing'});
  }
  Media_progress($event) {

  }

  Media_pause($event) {
    this.audioEvents.emit({'eventName': 'Paused'});
  }

  Media_seeking($event) {
    this.audioEvents.emit({'eventName': 'Seeking'});
  }

  Media_seeked($event) {
    this.audioEvents.emit({'eventName': 'Seeked'});
  }
  Media_volumechange($event) {
    this.audioEvents.emit({'eventName': 'Volume Changed'});
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

  sendRegistration() {
    this.register.emit(this);
  }

  loop(start: number, duration: number) {

    clearInterval(this.interval);

    this.loopParams.start = start;
    this.loopParams.duration = duration;
    this.loopParams.on = true;

    this.interval = setInterval(() => {
      this.play(this.loopParams.start);
    }, this.loopParams.duration);

  }
  /*
   * play from a certain point for a certain duration
   */
  play(start?: number, duration?: number) {

    if (!this.element.nativeElement.paused) { this.pause(); }

    if (start !== undefined) {
      this.setTime(start);
    }

    this.element.nativeElement.play();

    if (duration) {
      setTimeout(() => {
        this.pause();
      }, duration);
    }
  }

  /**
   * pause the element
   */
  pause() {
    clearInterval(this.interval);
    this.element.nativeElement.pause();
    this.audioEvents.emit({'eventName': 'Paused'});
  }

  /**
   * unpause the element
   */
  unpause() {
    this.audioEvents.emit({'eventName': 'Playing'});
    if (this.loopParams.on) {
      this.loopParams.paused = false;
      const currentTime = this.element.nativeElement.currentTime;
      const loopRemaining = this.loopParams.duration - 1000 * (currentTime - this.loopParams.start);
      this.element.nativeElement.play();
      setTimeout(() => {
        this.loop(this.loopParams.start, this.loopParams.duration);
      }, loopRemaining);
    } else {
      this.element.nativeElement.play();
    }
  }

  stop() {
    clearInterval(this.interval);
    this.loopParams = {
      on: false,
      paused: true,
      start: 0,
      duration: 0
    };
    this.element.nativeElement.pause();
    this.audioEvents.emit({'eventName': 'Stop'});
    this.setTime(0);
  }

  private setTime(position: number) {
    this.element.nativeElement.currentTime = position;
  }
}
